export default "__VITE_ASSET__frTC0Czs__"